"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { trackExperimentStarted } from "../server/TrackExperiment/TrackExperiment";

/**
 * Dedupes across React Strict Mode's mount→unmount→remount cycle.
 * Refs alone are not enough in React 19 Strict Mode, which remounts with
 * fresh state. Mixpanel Experiments cohorts are defined by first exposure.
 */
const firedAssignments = new Set<string>();

/**
 * Fires Mixpanel's `$experiment_started` from a real client mount, then
 * sends it through {@link trackExperimentStarted} (Mixpanel HTTP API).
 * No-ops when assignment is missing.
 */
export function TrackExperiment(t0) {
  const $ = _c(4);
  const {
    experimentId,
    variantId
  } = t0;
  let t1;
  let t2;
  if ($[0] !== experimentId || $[1] !== variantId) {
    t1 = () => {
      if (!experimentId || !variantId) {
        return;
      }
      const key = `${experimentId}:${variantId}`;
      if (firedAssignments.has(key)) {
        return;
      }
      firedAssignments.add(key);
      trackExperimentStarted({
        experimentId,
        variantId
      });
    };
    t2 = [experimentId, variantId];
    $[0] = experimentId;
    $[1] = variantId;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return null;
}